import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import "./Styles/VideoItem.css"

const VideoItem = ({ video, onVideoSelect }) => {
    return (
        <Grid container className='video_small_wrap'>
            <div onClick={() => onVideoSelect(video)} className='video_small'>
                <Grid>
                    <img src={video.snippet.thumbnails.default.url} />
                </Grid>
                <Grid lg={7} className='titles'>
                    <p className='video_title'>
                        {video.snippet.title}
                    </p>
                    <small>{video.snippet.channelTitle}</small>
                </Grid>
            </div>
        </Grid>
    )
}
export default VideoItem
